import { useCallback } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { matchPath } from 'react-router'

export const useSelectedTab = () => {
  const location = useLocation()
  return location.pathname
}

export const useIsSelected = (path) => {
  const currentPath = useSelectedTab()
  const result = matchPath(currentPath, { path, isExact: true, strict: true })
  return result !== null && result.isExact
}

export const useTab = (path) => {
  const history = useHistory()
  const isSelected = useIsSelected(path)

  const select = useCallback(() => {
    !isSelected && history.push(path)
  }, [path, history, isSelected])

  return [isSelected, select]
}
